var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4585 25.2188L15.4585 30.5521H15.4665C15.6342 30.6276 15.816 30.6667 15.9998 30.6667C16.1837 30.6667 16.3655 30.6276 16.5332 30.5521H16.5438L28.5438 25.2188C28.7791 25.1136 28.9789 24.9426 29.1189 24.7263C29.259 24.51 29.3334 24.2578 29.3332 24.0001V8.00009C29.3268 7.74357 29.2495 7.49383 29.1096 7.27868C28.9698 7.06352 28.773 6.89139 28.5412 6.78142L16.5412 1.44809C16.3707 1.37237 16.1863 1.33325 15.9998 1.33325C15.8133 1.33325 15.6289 1.37237 15.4585 1.44809L3.4585 6.78142C3.22675 6.89151 3.03005 7.06368 2.89024 7.2788C2.75043 7.49393 2.67299 7.7436 2.6665 8.00009V24.0001C2.66647 24.2581 2.74128 24.5105 2.88186 24.7268C3.02243 24.9431 3.22275 25.114 3.4585 25.2188ZM5.33317 10.0521L14.6665 14.2001V27.2814L5.33317 23.1334V10.0521ZM26.6665 23.1334L17.3332 27.2814V14.2001L26.6665 10.0521V23.1334ZM15.9998 4.12542L24.7172 8.00009L15.9998 11.8748L7.2825 8.00009L15.9998 4.12542Z",
    fill: "#31508C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.390669e6540eccf6b48db7befa2d596c.svg";
export { ForwardRef as ReactComponent };